import { useCallback } from 'react'

import { useTexts } from './useTexts'

export function useAutomatedMessageValidation() {
  const texts = useTexts()

  return useCallback(
    async (
      automatedMessage: string,
      automatedMessageEnabled: 'ON' | 'OFF',
      status: uui.domain.server.rm.VoiceConfig['status'],
      callbackConfigStatus: 'BACK_OFFICE' | 'OFF',
    ) => {
      if (
        status !== 'ADVANCED' ||
        callbackConfigStatus === 'BACK_OFFICE' ||
        automatedMessageEnabled === 'OFF'
      )
        return { automatedMessageError: null }

      const isEmpty = automatedMessage.trim().length === 0

      if (!isEmpty) return { automatedMessageError: null }

      return {
        automatedMessageError: {
          id: 'automatedMessageError',
          field: 'automatedMessage' as const,
          message: texts.automatedMessage.error.required,
          priority: 10,
        },
      }
    },
    [texts],
  )
}
